webpackJsonp([0,2],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("1DTc");
	module.exports = __webpack_require__("lVK7");


/***/ },

/***/ "u8RR":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProductTable = __webpack_require__("GJMX");
	
	var _ProductTable2 = _interopRequireDefault(_ProductTable);
	
	var _SearchBar = __webpack_require__("zOP/");
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FilterableProductTable = function (_Component) {
	  _inherits(FilterableProductTable, _Component);
	
	  function FilterableProductTable() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FilterableProductTable);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      filterText: '',
	      inStockOnly: false
	    }, _this.handleUserInput = function (filterText, inStockOnly) {
	      _this.setState({ filterText: filterText, inStockOnly: inStockOnly });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  FilterableProductTable.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_SearchBar2.default, {
	        filterText: this.state.filterText,
	        inStockOnly: this.state.inStockOnly,
	        onUserInput: this.handleUserInput
	      }),
	      _react2.default.createElement(_ProductTable2.default, {
	        products: this.props.products,
	        filterText: this.state.filterText,
	        inStockOnly: this.state.inStockOnly
	      })
	    );
	  };
	
	  return FilterableProductTable;
	}(_react.Component);
	
	exports.default = FilterableProductTable;

/***/ },

/***/ "GJMX":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductCategoryRow = function ProductCategoryRow(_ref) {
	  var category = _ref.category;
	  return _react2.default.createElement(
	    'tr',
	    null,
	    _react2.default.createElement(
	      'th',
	      { colSpan: '2' },
	      category
	    )
	  );
	};
	
	var ProductRow = function ProductRow(_ref2) {
	  var product = _ref2.product;
	  return _react2.default.createElement(
	    'tr',
	    null,
	    _react2.default.createElement(
	      'td',
	      null,
	      product.stocked ? product.name : _react2.default.createElement(
	        'span',
	        { style: { color: 'red' } },
	        product.name
	      )
	    ),
	    _react2.default.createElement(
	      'td',
	      null,
	      product.price
	    )
	  );
	};
	
	var _ref3 = _react2.default.createElement(
	  'thead',
	  null,
	  _react2.default.createElement(
	    'tr',
	    null,
	    _react2.default.createElement(
	      'th',
	      null,
	      'Name'
	    ),
	    _react2.default.createElement(
	      'th',
	      null,
	      'Price'
	    )
	  )
	);
	
	var ProductTable = function (_Component) {
	  _inherits(ProductTable, _Component);
	
	  function ProductTable() {
	    _classCallCheck(this, ProductTable);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ProductTable.prototype.render = function render() {
	    return _react2.default.createElement(
	      'table',
	      { className: 'table table-bordered table-compact' },
	      _ref3,
	      _react2.default.createElement(
	        'tbody',
	        null,
	        this.renderRows()
	      )
	    );
	  };
	
	  ProductTable.prototype.renderRows = function renderRows() {
	    var _props = this.props;
	    var filterText = _props.filterText;
	    var inStockOnly = _props.inStockOnly;
	    var products = _props.products;
	
	    var rows = [];
	    var lastCategory = null;
	    products.forEach(function (product) {
	      if (product.name.indexOf(filterText) === -1 || !product.stocked && inStockOnly) {
	        return;
	      }
	      if (product.category !== lastCategory) {
	        rows.push(_react2.default.createElement(ProductCategoryRow, { category: product.category, key: product.category }));
	      }
	      rows.push(_react2.default.createElement(ProductRow, { product: product, key: product.name }));
	      lastCategory = product.category;
	    });
	    return rows;
	  };
	
	  return ProductTable;
	}(_react.Component);
	
	exports.default = ProductTable;

/***/ },

/***/ "zOP/":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchBar = function (_Component) {
	  _inherits(SearchBar, _Component);
	
	  function SearchBar() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SearchBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleChange = function (e) {
	      var elements = e.target.form.elements;
	
	      _this.props.onUserInput(elements.filterTextInput.value, elements.inStockOnlyInput.checked);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  SearchBar.prototype.render = function render() {
	    return _react2.default.createElement(
	      "form",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "form-group" },
	        _react2.default.createElement("input", {
	          className: "form-control",
	          name: "filterTextInput",
	          onChange: this.handleChange,
	          placeholder: "Search...",
	          type: "text",
	          value: this.props.filterText
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "form-group" },
	        _react2.default.createElement(
	          "div",
	          { className: "checkbox" },
	          _react2.default.createElement(
	            "label",
	            null,
	            _react2.default.createElement("input", {
	              checked: this.props.inStockOnly,
	              name: "inStockOnlyInput",
	              onChange: this.handleChange,
	              type: "checkbox"
	            }),
	            ' ',
	            "Only show products in stock"
	          )
	        )
	      )
	    );
	  };
	
	  return SearchBar;
	}(_react.Component);
	
	exports.default = SearchBar;

/***/ },

/***/ "cilB":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "lVK7":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__("Jmt5");
	
	__webpack_require__("cilB");
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("O27J");
	
	var _FilterableProductTable = __webpack_require__("u8RR");
	
	var _FilterableProductTable2 = _interopRequireDefault(_FilterableProductTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var products = [{ category: 'Sporting Goods', price: '$49.99', 'stocked': true, name: 'Football' }, { category: 'Sporting Goods', price: '$9.99', 'stocked': true, name: 'Baseball' }, { category: 'Sporting Goods', price: '$29.99', 'stocked': false, name: 'Basketball' }, { category: 'Electronics', price: '$99.99', 'stocked': true, name: 'iPod Touch' }, { category: 'Electronics', price: '$399.99', 'stocked': false, name: 'iPhone 5' }, { category: 'Electronics', price: '$199.99', 'stocked': true, name: 'Nexus 7' }];
	
	(0, _reactDom.render)(_react2.default.createElement(_FilterableProductTable2.default, { products: products }), document.querySelector('#app'));

/***/ },

/***/ "1DTc":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// Ensure polyfill compatibility between create-react-app and zero-config nwb apps.
	// This is from https://github.com/facebookincubator/create-react-app/blob/master/config/polyfills.js
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behaviour.
	  __webpack_require__("BY8e").enable();
	  window.Promise = __webpack_require__("2FwT");
	}
	
	// fetch() polyfill for making API calls
	__webpack_require__("cvZT");
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__("bo3j");

/***/ }

});


/** WEBPACK FOOTER **
 ** app.3e7086d8.js
 **/